import { Card, CardContent, Divider, Grid, useMediaQuery } from '@mui/material';
import { Info } from '@mui/icons-material';
import {Row, Tooltip, Col , Collapse, Modal } from 'antd';
import MessageRenderer from 'components/MessageRenderer';
import SentryWrap from 'components/Sentry';
import React, { useCallback, useState } from 'react';
import { useAudioChecker } from "store/audio/selectors";
import styled from 'styled-components';
import { AIfeebackImage, AiFeedbackImage, PlacementSectionNumberBg } from 'utils/assets/images';
import COLOR from "utils/constants/color";
import { v4 } from "uuid";
import AudioReader from "components/audio/audioReader";
import { CaretDownOutlined } from '@ant-design/icons';
import ViewPlacementRucbrics from './ViewRubrics';
import { useRubrices } from 'store/rubric/selectors';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import ModalMenu from 'components/Modals';
import ReactPlayer from 'react-player';
import { CloudFlarePreview } from 'components/UI';
const alphaRef = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
// Styled components for custom styling
const { Panel } = Collapse;
const SectionContainer = styled(Card)`
  margin-bottom: 20px;
  border: 1px solid #e0e0e0;
  @media print {
    display: block !important;
    overflow: visible !important;
    box-shadow: none !important;
  }
`;



const QUESTION_TYPES = {
    MULTIPLE_CHOICE: 'multipleChoice',
    ESSAY: 'essay',
    AUDIO: 'audio',
    AUDIO_MULTICHOICE: 'audio_multichoice',
    AUDIO_WRITTEN_RESPONSE: 'audio_written_response',
    TRUE_FALSE: 'trueFalse',
};

const getPrintableVideoPoster = (videoUrl = '') => {
    if (!videoUrl || typeof videoUrl !== 'string') return '';
    try {
        const parsed = new URL(videoUrl);
        const poster = parsed.searchParams.get('poster');
        if (!poster) return '';
        return decodeURIComponent(poster);
    } catch (error) {
        return '';
    }
};
const Answer = styled.span`
    color: ${p => p.correct ? COLOR.green100 : 'red'};
    display: block;
    font-size: 14px;
    font-weight: 600;
    text-decoration: ${p => !p.correct ? 'line-through' : 'none'};
`;




const Question = styled.span`
    display: block;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 12px;
    @media print {
        display: block;
        break-inside: avoid;
        page-break-inside: avoid;
    }
`;
const AudioQuestion = styled(Question)`
    align-items: center;
    column-gap: 8px;
    @media print {
        display: flex !important;
        align-items: center !important;
        column-gap: 8px !important;
    }
`;
const QuestionAudio = styled.audio`
    max-width: 100%;
    @media print {
        width: 620px;
        max-width: calc(100% - 40px);
    }
`;
const QuestionIndexes = styled.span`
    font-size: 14px;
    font-weight: 600;
    margin-right: 4px;
`;



const AIContent = styled.div`
    text-align: left;
    width: 100%;
    border-radius: 20px;
    // padding-right: 20px;
    // padding-top: 20px;
    // padding-bottom: 10px;
    // padding-left: 30px;
    padding:25px 25px 20px 25px;
    background: rgb(241,235,251);
    font-size: 13px;
    font-weight: 500;
    margin-top: 10px;
`;
const ErrorAiArea = styled.div`
   background:rgb(82 50 128);
   border-radius:10px;
   position: relative;
   color: ${COLOR.white};
   width: 230px;
   padding-left: 10px;
   height: 26px;
   padding-top: 1px;
   margin-top: 25px;
`;
const GridContainer = styled(Grid)`
  display: block !important;
`
const AllAiSection = styled.div`
    display:flex;
    align-items: center;
`

const AIIcon = styled.img`
    position: absolute;
    height: 50px;
    width: 45px;
    top: -20px;
    right: -15px;
`;
const AIIcons = styled.img`
    position: absolute;
    height: 45px;
    width:38px;
    top: -18px;
    right: -12px;
`;
const ErrorAiAreas = styled.div`
   background:#38b54b;
   border-radius:10px;
   position: relative;
   color: ${COLOR.white};
   width: 230px;
   padding-left: 10px;
   height: 26px;
   padding-top: 1px;
   margin-top: 25px;
   margin-right:2px;
`;


/** Outer dashed box — keep a single inner cluster so print does not split between flex items. */
const ImageAnswerArea = styled.div`
  display: block;
  border: 0.4px dotted black;
  margin-top: 15px;
  padding: 15px 10px;
  position: relative;
  @media print {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    overflow: visible !important;
  }
`;

/** All answer content lives here; one box prevents page breaks between badge / audio / text. */
const ImageAnswerCluster = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  col-gap: 10px;
  width: 100%;
  @media print {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    display: block !important;
  }
`;

const AnswerMarkLagendaArea = styled.div`
  position : absolute;
  left : 10px;
  background-color: #e3e4ef;
  box-shadow: 0px 1px 2px #80808099;
  top: -12px;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 10px;
  font-weight: bold;
  @media print {
    position: static;
    left: auto;
    top: auto;
    display: inline-block;
    margin-bottom: 6px;
    box-shadow: none;
  }
`
const QuestionArea = styled.div`
  margin-bottom: 20px;
  background-color: #ffffff0f;
  box-shadow: 0px 0px 0px 0px #80808070, 0px 1px 1px 1px #80808082;
  padding: 5px;
  @media print {
    break-inside: avoid-page !important;
    page-break-inside: avoid !important;
    display: block !important;
    overflow: visible !important;
    padding: 4mm;
    padding-top: 5mm;
    padding-bottom: 5mm;
  }
`;

const PlacementPrintQuestionBlock = styled.div.attrs(() => ({
  className: 'placement-print-question-block',
}))`
  @media print {
    break-inside: avoid-page !important;
    page-break-inside: avoid !important;
    display: block !important;
    overflow: visible !important;
    page-break-after: auto !important;
  }
`;

const PlacementPointLabel = styled.p`
  float: right;
  margin-right: 5px;
  @media print {
    float: none;
    text-align: right;
    width: 100%;
    margin: 0 0 8px 0;
    page-break-after: avoid;
    break-after: avoid;
  }
`;

const NumberContainer = styled.span`
    height: 28px;
    width: 30px;
    font-size: 19px;
    border-radius:50%;
    background-image:url(${PlacementSectionNumberBg});
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: #ffff00eb;
      text-shadow: -1px -2px 0px #1b1a1a,  
              1px -1px 0px #1b1a1a,  
             -1px  1px 0px #1b1a1a,  
              1px  1px 0px #1b1a1a;
    font-style: italic;
    margin: 0 4px;
    vertical-align: middle;
`;

/** Inner wrapper keeps “Section … speaking” on one print fragment (avoids split mid-heading). */
const SectionTitleInner = styled.span`
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  gap: 0.15em;
  text-align: center;
  max-width: 100%;
  @media print {
    display: inline-block !important;
    width: 100%;
    box-sizing: border-box;
    white-space: nowrap;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
    page-break-after: avoid;
    orphans: 2;
    widows: 2;
  }
`;

const SectionTitle = styled.h2`
   display: flex;
   align-items: center;
   font-size: 28px;
   justify-content: center;
   white-space: nowrap;
   @media print {
     display: block !important;
     text-align: center;
     white-space: nowrap;
     font-size: 32px;
     break-inside: avoid !important;
     page-break-inside: avoid !important;
     page-break-after: avoid;
     orphans: 2;
     widows: 2;
   }
`;
const SectionGradeDisplay = styled.div`
    font-size: 18px;
    border-radius: 25px;
    background: #f3f3f3;
    width: fit-content;
    padding-left: 12px;
    padding-right: 12px;
    color: #f55454;
    box-shadow: 1px 1px 1px #808080bf, 0px -1px 1px #80808069;
    margin-left: -5px;
    margin-bottom: 6px;
`;
const Footer = styled.footer`
  text-align: center;
  padding: 1rem 0;
  color: #4b5563;
  font-size: 0.875rem;
  width: 100%;
`;

const CopyrightNotice = () => {
  const currentYear = new Date().getFullYear();

  return <Footer>&copy; {currentYear} 1WayEducation. All rights reserved.</Footer>;
};
const QuestionIndex = ({ index }) => {
    return (
        <QuestionIndexes>
            {index+1}.
        </QuestionIndexes>
    );
};
const CustomCaretDownOutlined = styled(CaretDownOutlined)`
    font-size: 11px;
    margin-left: 6px;
    transform: ${(props) => (props.isActive ? "rotate(180deg)" : "rotate(0deg)")};
    color: #fff !important;
`;
const GradeAiArea = styled.div`
   background:rgb(7 140 132);
   border-radius:10px;
   position: relative;
   color: ${COLOR.white};
   width: 230px;
   padding-left: 10px;
   height: 26px;
   padding-top: 1px;
   margin-top: 25px;
   display: flex;
`;
const AiGradeArea = styled.span`
   background-color: #faad14;
    color: #fff;
    padding: 4px;
    border-radius: 50%;
    padding-left: 8px;
    padding-right: 8px;
    text-shadow: 2px 2px 2px gray;
`;

const GetGrade = (value) =>{
    if(typeof value === 'string'){
        const g = parseInt(value, 10);
        return Math.ceil(g)
    }else if(typeof value === 'number'){
        return Math.ceil(value)
    }else{
        return value
    }
}

const hasMeaningfulAiDisplayString = (value) => {
    if (value == null || typeof value !== 'string') return false;
    const t = value.trim();
    if (t === '') return false;
    const lower = t.toLowerCase();
    if (lower === 'null' || lower === 'undefined') return false;
    return true;
};

const resolveAiErrorsBodyHtml = (ai_feedback, ai_grade_feedback) => {
    if (hasMeaningfulAiDisplayString(ai_feedback)) return ai_feedback;
    if (hasMeaningfulAiDisplayString(ai_grade_feedback)) return ai_grade_feedback;
    return null;
};

const AIGradingFeedback = ({ ai_grade, languageData , id}) => {
    const audioChecker = useAudioChecker();
    const [activeKey, setActiveKey] = useState('1');
    if (!ai_grade) return null;
    const { ai_grade_point, ai_grade_feedback  } = ai_grade;
    return (<div style={{ position: "relative" }} className="gradefeed_area">
        <div style={{ display: "flex", width: "100%", justifyContent: "flex-end" }}>
            <Collapse
                className="gradefeedback"
                expandIcon={({ isActive }) =><CustomCaretDownOutlined isActive={isActive} />}
                bordered={false}
                activeKey={activeKey}
                style={{ background: "none" , width:"100%" }}
                onChange={(keys) => setActiveKey(keys)}
            >
                <Panel
                    header={
                        <span style={{ fontWeight: "bold" , color:"#fff" }}>
                            Calificado por IA: <AiGradeArea>{GetGrade(ai_grade_point)}</AiGradeArea> 
                        </span>
                    }
                    key="1"
            
                >
                    <div style={{ position: "relative" }}>
                        <div
                            // className="feedBackSound"
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                // marginTop:"-44px"
                            }}
                        >
                            <GradeAiArea>
                                <span style={{display:'flex', alignItems:'center'}}> 
                                    <p style={{margin:'0px'}}>Explicación del grado de IA</p> 
                                    <AIUsageInfo styles={{ icon: { fontSize: 16, color: 'white', height:'24px' } }} /> 
                                </span>
                                <AIIcon src={AIfeebackImage} />
                            </GradeAiArea>
                            <AudioReader
                                text={hasMeaningfulAiDisplayString(ai_grade_feedback) ? ai_grade_feedback : ''}
                                audioChecker={audioChecker}
                                id={id}
                                language={languageData}
                                styles={{ width:90}}
                            />
                        </div>
                    </div>
                    <AIContent>
                        {hasMeaningfulAiDisplayString(ai_grade_feedback)
                            ? ai_grade_feedback
                            : 'Waiting for a grade...'}
                    </AIContent>
                </Panel>
            </Collapse>
        </div>
    </div>)
}

const AIFeedback = ({ ai_feedback, ai_suggestion, id, languageData, ai_grade }) => {
    const text = "Consejos para mejorar";
    const maxLength = 12;
    const isMobile = useMediaQuery('(max-width: 1250px)');
    const stripTags = (input) => {
        if (!input) return '';
        let strippedInput = input.replace(/<[^>]*>?/gm, '');
        strippedInput = strippedInput.replace(/```html|```|\*\*/g, '');
        return strippedInput;
    };

    const audioChecker = useAudioChecker();

    const errorsBodyHtml = resolveAiErrorsBodyHtml(ai_feedback, ai_grade?.ai_grade_feedback);
    const hasSuggestionContent = hasMeaningfulAiDisplayString(ai_suggestion);

    if (!errorsBodyHtml && !hasSuggestionContent) {
        return null;
    }

    return (
        <div style={{ position: "relative" }}>
            {errorsBodyHtml ? (
                <>
                    <Row>
                        <Col md={24} sm={24} lg={18} >
                            <AllAiSection>
                                <ErrorAiArea> Errores y cambios necesarios  <AIIcon src={AIfeebackImage} /></ErrorAiArea><div style={{ marginTop: 26, marginLeft: 10, cursor: "help" }} >
                                    <Tooltip
                                        placement={"topLeft"}
                                        trigger={"hover"}
                                        title={'If any questions arise or errors are detected, please ensure that you review them carefully and make the necessary corrections.'}>
                                        <Info />
                                    </Tooltip>
                                </div>
                            </AllAiSection>
                        </Col>
                    </Row>
                    <AIContent dangerouslySetInnerHTML={{ __html: errorsBodyHtml }} />
                </>
            ) : null}
            {hasSuggestionContent ? (
                <div style={{ position: 'relative' }}>
                    <Row>
                        <Col md={24} sm={24} xs={18} lg={18}>
                            <AllAiSection>
                                <ErrorAiAreas>
                                    <div>
                                        {text.length > maxLength ? (
                                            isMobile ? (
                                                <Tooltip title={text}>
                                                    <span>{text.slice(0, maxLength) + '...'}</span>
                                                </Tooltip>
                                            ) : (
                                                <span>{text}</span>
                                            )
                                        ) : (
                                            <span>{text}</span>
                                        )}
                                        <AIIcons src={AiFeedbackImage} />
                                    </div>
                                </ErrorAiAreas>
                                <div style={{ marginTop: 26, marginLeft: 10, cursor: "help", zIndex: 99 }} >
                                    <Tooltip
                                        placement={"topLeft"}
                                        trigger={"hover"}
                                        title={'Should any questions arise or errors be detected, please, ask your teacher for feedback.'}>
                                        <Info />
                                    </Tooltip>
                                </div>
                            </AllAiSection>
                        </Col>
                        <Col md={24} sm={24} xs={6} lg={6}>
                            <div className="feedBackSound" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0', width: '100%' }}>
                                <AudioReader
                                    text={stripTags(ai_suggestion)}
                                    audioChecker={audioChecker}
                                    id={id}
                                    language={languageData}
                                />
                            </div>
                        </Col>
                    </Row>
                    <AIContent dangerouslySetInnerHTML={{ __html: stripTags(ai_suggestion) }} />
                </div>
            ) : null}
        </div>
    );
};
const Multichoice = ({ questionIndex, question, answer, setSelectedAnswerImage, setImagePreviewModal }) => {
    const isCorrect = question?.answer === answer?.answer;
    const ans = answer?.answer;
    const question_text = question?.question
    const options = question?.options ||[]
    const q_answer = question?.answer;
    const image = question?.image;
    return (<QuestionArea>
        <Question> <QuestionIndex index={questionIndex} /> {question_text}</Question>
        {image ?  <PictureImages 
                        className="cursor-zoomIn gradeBook-answer-image-width-height" 
                        onClick={() => {
                            setSelectedAnswerImage(image);
                            setImagePreviewModal(true);
                        }} 
                        src={image} 
                    /> : null}
        <ImageAnswerArea>
            <ImageAnswerCluster>
                <AnswerMarkLagendaArea>Answer</AnswerMarkLagendaArea>
                <Answer correct={isCorrect}>
                    {alphaRef[ans]} - {options[ans]}
                </Answer>
                {!isCorrect && (
                    <Answer correct>
                        {alphaRef[q_answer]} - {options[q_answer]}
                    </Answer>
                )}
            </ImageAnswerCluster>
        </ImageAnswerArea>
    </QuestionArea>)

}
const WrittenResponse = ({ questionIndex, question, answer, aiFeedback, aiSuggestion, languageData = '' , ai_grade, setSelectedAnswerImage, setImagePreviewModal }) => {
    const ans = answer?.answer || '';
    const question_text = question?.question
    const image = question?.image
    return (<QuestionArea>
        <Question><QuestionIndex index={questionIndex} /> {question_text}</Question>
        {image ?  <PictureImages 
                        className="cursor-zoomIn gradeBook-answer-image-width-height" 
                        onClick={() => {
                            setSelectedAnswerImage(image);
                            setImagePreviewModal(true);
                        }} 
                        src={image} 
                    /> : null}
        <ImageAnswerArea>
            <ImageAnswerCluster>
                <AnswerMarkLagendaArea>Answer</AnswerMarkLagendaArea>
                <MessageRenderer style={{ color: 'rgb(0, 0, 0)' }} data={ans || ''} />
                <AIGradingFeedback ai_grade={ai_grade} languageData={languageData}  id={v4()} />
                <AIFeedback ai_feedback={aiFeedback} ai_suggestion={aiSuggestion} ai_grade={ai_grade} id={v4()} languageData={languageData} />
            </ImageAnswerCluster>
        </ImageAnswerArea>
    </QuestionArea>)

}
const AudioResponse = ({ question, answer, questionIndex , ai_grade , languageData, setSelectedAnswerImage, setImagePreviewModal }) => {
    const ans = answer?.answer || '';
    const audio_url = question?.audio
    const question_text = question?.question
    return (<QuestionArea>
        <AudioQuestion><QuestionIndex index={questionIndex} /> {audio_url ? <QuestionAudio controls controlsList="nodownload" src={audio_url} /> : question_text}</AudioQuestion>
        {ans ? <ImageAnswerArea>
            <ImageAnswerCluster>
                <AnswerMarkLagendaArea>Answer</AnswerMarkLagendaArea>
                <QuestionAudio controls controlsList="nodownload" src={ans} />
                <AIGradingFeedback ai_grade={ai_grade} languageData={languageData}  id={v4()} />
            </ImageAnswerCluster>
        </ImageAnswerArea> : null}
    </QuestionArea>)

}
const AudioWithMultichoiceResponse = ({ questionIndex, question, answer, aiFeedback, aiSuggestion, languageData ,ai_grade, setSelectedAnswerImage, setImagePreviewModal }) => {
    const isCorrect = question?.answer === answer?.answer;
    const ans = answer?.answer;
    const audio_url = question?.audio
    const question_text = question?.question
    const options = question?.options ||[]
   const q_answer = question?.answer 
    return (<QuestionArea>
        <AudioQuestion><QuestionIndex index={questionIndex} /> {audio_url ? <QuestionAudio controls controlsList="nodownload" src={audio_url} /> : question_text}</AudioQuestion>
        <ImageAnswerArea>
            <ImageAnswerCluster>
                <AnswerMarkLagendaArea>Answer</AnswerMarkLagendaArea>
                <Answer correct={isCorrect}>
                    {alphaRef[ans]} - {options[ans] ||''}
                </Answer>
                {!isCorrect && (
                    <Answer correct>
                        {alphaRef[q_answer]} - {options[q_answer]||''}
                    </Answer>
                )}
            </ImageAnswerCluster>
        </ImageAnswerArea>
    </QuestionArea>)

}
const AudioWithWrittenResponse = ({ questionIndex, question, answer, aiFeedback, aiSuggestion, languageData , ai_grade, setSelectedAnswerImage, setImagePreviewModal }) => {
    const ans = answer?.answer || '';
    const audio_url = question?.audio
    const question_text = question?.question
    return (<QuestionArea>
        <AudioQuestion><QuestionIndex index={questionIndex} /> {audio_url ? <QuestionAudio controls controlsList="nodownload" src={audio_url} /> : question_text}</AudioQuestion>
        <ImageAnswerArea>
            <ImageAnswerCluster>
                <AnswerMarkLagendaArea>Answer</AnswerMarkLagendaArea>
                <MessageRenderer style={{ color: 'rgb(0, 0, 0)' }} data={ans} />
                <AIGradingFeedback ai_grade={ai_grade} languageData={languageData}  id={v4()} />
                <AIFeedback ai_feedback={aiFeedback} ai_suggestion={aiSuggestion} ai_grade={ai_grade} id={v4()} languageData={languageData} />
            </ImageAnswerCluster>
        </ImageAnswerArea>
    </QuestionArea>)

}
const QuestionRenderer = ({ question, answer, sectionIndex, questionIndex , ai_grade ,  aiFeedback, aiSuggestion, hasRubric, setSelectedAnswerImage, setImagePreviewModal }) => {
    const pointLabel = hasRubric
        ? <PlacementPointLabel>Rubric Applied</PlacementPointLabel>
        : (!!question.max_point ? (
            <PlacementPointLabel>
                Question Point: {ai_grade?.ai_grade_point} / {question.max_point || 0}
            </PlacementPointLabel>
        ) : null);
    switch (question.type) {
        case QUESTION_TYPES.TRUE_FALSE:
        case QUESTION_TYPES.MULTIPLE_CHOICE:
            return (
                <PlacementPrintQuestionBlock>
                    {pointLabel}
                    <Multichoice questionIndex={questionIndex} question={question || {}} answer={answer || {}} ai_grade={ai_grade}  aiFeedback={aiFeedback} aiSuggestion={aiSuggestion} setSelectedAnswerImage={setSelectedAnswerImage} setImagePreviewModal={setImagePreviewModal} />
                </PlacementPrintQuestionBlock>
            );

        case QUESTION_TYPES.ESSAY:
            return (
                <PlacementPrintQuestionBlock>
                    {pointLabel}
                    <WrittenResponse question={question || {}} answer={answer || {}} questionIndex={questionIndex} ai_grade={ai_grade} aiFeedback={aiFeedback} aiSuggestion={aiSuggestion} setSelectedAnswerImage={setSelectedAnswerImage} setImagePreviewModal={setImagePreviewModal} />
                </PlacementPrintQuestionBlock>
            );

        case QUESTION_TYPES.AUDIO:
            return (
                <PlacementPrintQuestionBlock>
                    {pointLabel}
                    <AudioResponse question={question || {}} answer={answer || {}} questionIndex={questionIndex} ai_grade={ai_grade} aiFeedback={aiFeedback} aiSuggestion={aiSuggestion} setSelectedAnswerImage={setSelectedAnswerImage} setImagePreviewModal={setImagePreviewModal} />
                </PlacementPrintQuestionBlock>
            );

        case QUESTION_TYPES.AUDIO_MULTICHOICE:
            return (
                <PlacementPrintQuestionBlock>
                    {pointLabel}
                    <AudioWithMultichoiceResponse question={question || {}} answer={answer || {}} questionIndex={questionIndex} ai_grade={ai_grade} aiFeedback={aiFeedback} aiSuggestion={aiSuggestion} setSelectedAnswerImage={setSelectedAnswerImage} setImagePreviewModal={setImagePreviewModal} />
                </PlacementPrintQuestionBlock>
            );

        case QUESTION_TYPES.AUDIO_WRITTEN_RESPONSE:
            return (
                <PlacementPrintQuestionBlock>
                    {pointLabel}
                    <AudioWithWrittenResponse question={question || {}} answer={answer || {}} questionIndex={questionIndex} ai_grade={ai_grade}  aiFeedback={aiFeedback} aiSuggestion={aiSuggestion} setSelectedAnswerImage={setSelectedAnswerImage} setImagePreviewModal={setImagePreviewModal} />
                </PlacementPrintQuestionBlock>
            );
        default:
            return null;
    }
};

export const QuizReview = ({ sections, answers , submission={} }) => {
    const all_rubrics = useRubrices();
    const ai_feedback = submission?.ai_feedback || []
    const ai_suggestion = submission?.ai_suggestion || []
    const ai_grade = submission?.ai_grade || []
    const ai_grading_by_sections = submission?.ai_grading_by_sections || []
    const getAiFeedback = (sectionIndex, questionIndex) => {
        if (ai_feedback && ai_feedback[sectionIndex] && ai_feedback[sectionIndex][questionIndex]) {
            return ai_feedback[sectionIndex][questionIndex]

        }
        return null
    };
    const getAiSuggestion = (sectionIndex, questionIndex) => {
        if (ai_suggestion && ai_suggestion[sectionIndex] && ai_suggestion[sectionIndex][questionIndex]) {
            return ai_suggestion[sectionIndex][questionIndex]

        }
        return null
    };
    const getAiGrade = (sectionIndex, questionIndex) => {
        if (ai_grade && ai_grade[sectionIndex] && ai_grade[sectionIndex][questionIndex]) {
            return ai_grade[sectionIndex][questionIndex]

        }
        return null
    };
    const getAnswer = (sectionIndex, questionIndex) => {
        if (answers && answers[sectionIndex] && answers[sectionIndex][questionIndex]) {
            return answers[sectionIndex][questionIndex]

        }
        return null
    };
    const getSectionMarks = (section,sectionIndex)=>{
        const { rubric_id, max_point, } = section;
        if (rubric_id) {
            const ai_dt = ai_grading_by_sections[sectionIndex]
            if (ai_dt) {
                const { grade_point } = ai_dt
                return `${grade_point || 0} / ${max_point || 0} `

            }
            return `- / ${max_point || 0} `
        }
        let marks = 0;
        section.questions.forEach((question, questionIndex) => {
            const ai_grade = getAiGrade(sectionIndex, questionIndex)
            if(ai_grade&&ai_grade.ai_grade_point){
                marks += ai_grade.ai_grade_point||0
            }
        });
        return  `${marks||0} / ${max_point || 0} `
    }
    const getRubricSubmission = (section, sectionIndex) => {
        const { rubric_id } = section;
        if (rubric_id) {
            const ai_dt = ai_grading_by_sections[sectionIndex]
            if (ai_dt) {
                const { rubrics_data } = ai_dt
                return rubrics_data || {}

            }
        }
        return {}
    }
    const getRubricsInfo = useCallback((section) => {
        const { rubric_id, max_point, } = section;
        return all_rubrics?.find(k => k.id == rubric_id) || {}
    }, [all_rubrics])
    const rubricSection = (section,sectionIndex) => {
        if (!section || !section.rubric_id) return null;
        return <ViewPlacementRucbrics
            currentSubmissionRubric={getRubricSubmission(section, sectionIndex)}
            assignmentRubrics={getRubricsInfo(section)}
            rubricSection={false}
            type={""}
            isMobileMenu={false}
            ai_grade_feedback={{}}
        />
    }

    const [selectedAnswerImage, setSelectedAnswerImage] = useState(null);
    const [imagePreviewModal, setImagePreviewModal] = useState(false);

    const Player = ({ url }) => {
        return (<AuidoPlayerWrapper style={{ width: '100%' }}>
            <ReactPlayer
                url={url}
                height="40px"
                width="100%"
                controls
                playsinline
                onPlay={() => {
    
                }}
                onPause={() => {
    
                }}
                onEnded={() => { }}
                // style={{ marginBottom: '8px' }}
                config={{ file: { forceAudio: true, attributes: { controlsList: 'nodownload' } } }}
            />
        </AuidoPlayerWrapper>)
    }

    const [imageZoomOpen, setImageZoomOpen] = useState(false);


    return (<SentryWrap className='printable'>
        <GridContainer container spacing={3} className='printable'>
            {sections.map((section, sectionIndex) => (
                <Grid item xs={12} key={sectionIndex}>
                    <SectionContainer className="printable-section">
                        <CardContent className="placement-exam-card-content">
                            <SectionTitle className="placementSectionTitle 1111">
                                <SectionTitleInner className="placement-section-title-inner">
                                    Section <NumberContainer>{sectionIndex + 1}</NumberContainer>
                                    {section?.title_section || ''} &nbsp;{section?.category_type || ''}
                                </SectionTitleInner>
                            </SectionTitle>

                            {section?.instruction ? (
                                <Question className="instruction-content" dangerouslySetInnerHTML={{ __html: section.instruction }} />
                            ) : null}

                        <SectionMediaBlock>
                            {section?.video ? 
                            <>
                                <VideoContainer style={{marginBottom: "10px"}}>
                                    <CloudFlarePreview iframeUrl={section?.video} is_placement={true} autoplay={false} allowFullScreen={true} />
                                </VideoContainer>
                                <VideoPrintFallback>
                                    <strong>This is Video</strong>: Preview in print.
                                    {getPrintableVideoPoster(section?.video) ? (
                                        <VideoPrintPoster src={getPrintableVideoPoster(section?.video)} alt="video preview thumbnail" />
                                    ) : null}
                                </VideoPrintFallback>
                            </> : null}
                            {section?.audio ? <Player url={section.audio} /> : null}
                            {section?.image ? (
                                <>
                                    <ImageZoomWrap onClick={() => setImageZoomOpen(true)} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && setImageZoomOpen(true)}>
                                        <Image src={section.image} alt="section image" />
                                    </ImageZoomWrap>
                                    <Modal
                                        open={imageZoomOpen}
                                        onCancel={() => setImageZoomOpen(false)}
                                        footer={null}
                                        width="max-content"
                                        styles={{ body: { padding: 16, display: 'flex', justifyContent: 'center', alignItems: 'center' } }}
                                        centered
                                    >
                                        <ZoomedImage src={section.image} alt="section image zoom" />
                                    </Modal>
                                </>
                            ) : null}
                            </SectionMediaBlock>



                            <SectionGradeDisplay>
                              {getSectionMarks(section,sectionIndex)}
                            </SectionGradeDisplay>

                           {rubricSection(section,sectionIndex)}
                            <Divider />
                              {section.questions.map((question, questionIndex) => (
                                <QuestionRenderer
                                    key={questionIndex}
                                    question={question}
                                    sectionIndex={sectionIndex}
                                    questionIndex={questionIndex}
                                    hasRubric={!!section?.rubric_id}
                                    answer={getAnswer(sectionIndex, questionIndex)}
                                    aiFeedback={getAiFeedback(sectionIndex, questionIndex)}
                                    aiSuggestion={getAiSuggestion(sectionIndex, questionIndex)}
                                    ai_grade={getAiGrade(sectionIndex, questionIndex)}
                                    setSelectedAnswerImage={setSelectedAnswerImage}
                                    setImagePreviewModal={setImagePreviewModal}
                                />
                              ))}

                    <ModalMenu 
                        type="imageModal" 
                        image={selectedAnswerImage} 
                        open={imagePreviewModal} 
                        close={() => {
                            setImagePreviewModal(false);
                            setSelectedAnswerImage(null);
                        }} 
                    />
                        </CardContent>
                    </SectionContainer>
                </Grid>
            ))}
            <CopyrightNotice/>
        </GridContainer>
    </SentryWrap>
    );
};

const PictureImages = styled.img`
  background-color: ${COLOR.white};
//   box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
  border-radius:8px;
  height: 100%;
  width: fit-content;
  max-width: 250px;
  max-height: 250px;
`;

const AuidoPlayerWrapper = styled.div`
    min-width: 250px;
    max-width: 500px;
    padding:0px 16px;
    margin-bottom:10px;
    margin-top: 10px;
`;

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-height: 190px;
`;

const ImageZoomWrap = styled.div`
    cursor: pointer;
    display: inline-block;
    max-width: 100%;
`;

const ZoomedImage = styled.img`
    max-width: 90vw;
    max-height: 85vh;
    width: auto;
    height: auto;
    object-fit: contain;
`;

const VideoContainer = styled.div`
  width: 100%;
  max-width: 480px;
  aspect-ratio: 6 / 4;
  margin-bottom: 0px;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  margin-bottom: 19px;

  @media screen and (max-width: 900px) {
    max-width: 100%;
  }
  @media print {
    display: none !important;
  }
`;

const VideoPrintFallback = styled.div`
  display: none;
  @media print {
    display: block;
    width: 100%;
    max-width: 360px;
    text-align: center;
    margin: 6px auto 10px auto;
    padding: 8px 10px;
    border: 1px dashed #9aa0a6;
    border-radius: 6px;
    color: #111 !important;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
`;

const VideoPrintPoster = styled.img`
  display: none;
  @media print {
    display: block;
    width: 100%;
    max-width: 260px;
    max-height: 170px;
    object-fit: cover;
    border-radius: 4px;
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
`;

const SectionMediaBlock = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  @media print {
    break-inside: avoid !important;
    page-break-inside: avoid !important;
  }
`;
